import { inject, DOCUMENT } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { RESPONSE } from '../../express.token';

export const redirectInterceptor: HttpInterceptorFn = (req, next) => {
  const document = inject(DOCUMENT);
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle 301/302 redirects (primarily for client-side)
      // SSR redirects are handled by the resolver before component loads
      if (error.status === 301 || error.status === 302) {
        const redirectUrl = error.headers.get('location');
        
        if (redirectUrl && isPlatformBrowser(platformId)) {
          // Client-side redirect handling
          handleClientRedirect(redirectUrl, document, router);
          return throwError(() => ({
            ...error,
            isRedirect: true,
            redirectUrl: redirectUrl,
          }));
        }
      }
      return throwError(() => error);
    }),
  );
};

function handleClientRedirect(
  redirectUrl: string,
  document: Document,
  router: Router
): void {
  // Client-side: Navigate using Angular router
  // Check if it's an internal URL
  try {
    const url = new URL(redirectUrl, document.location.origin);
    if (url.origin === document.location.origin) {
      // Internal redirect - use Angular router
      router.navigateByUrl(url.pathname + url.search);
    } else {
      // External redirect - use window.location
      window.location.href = redirectUrl;
    }
  } catch {
    // If URL parsing fails, treat as external
    window.location.href = redirectUrl;
  }
} 